import React, { Component } from "react";
import RegisterForm from "../../../components/auth/RegisterForm";
import { connect } from "react-redux";
import { register } from "../../../store/iam/operations";
import RegisterValidators from "./validators";
import { navigate } from "../../../store/navigation/operations";
import ReactGA from "react-ga";

export class Register extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleGoToLogin = this.handleGoToLogin.bind(this);
  }

  handleSubmit(user_name, password, first_name, last_name) {
    ReactGA.event({
      category: "User",
      action: "Created an Account"
    });
    const payload = {
      u_name: user_name.toLowerCase(),
      email: user_name,
      f_name: first_name,
      l_name: last_name,
      locale: this.props.locale,
      pw: password
    }
    this.props
      .register(payload, this.props.redirectTo)
      .then(() => {
        if (this.props.onAuthCallback) {
          this.props.onAuthCallback();
        }
      });
  }
  handleGoToLogin() {
    if (this.props.onLoginClick) {
      this.props.onLoginClick();
    } else {
      this.props.navigate("/login");
    }
  }
  render() {
    return (
      <div>
        <RegisterForm
          isOpen={this.props.isOpen}
          onClose={this.props.onClose}
          onRegister={this.handleSubmit}
          validators={RegisterValidators}
          isLoading={this.props.loading}
          goToLogin={this.handleGoToLogin}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  locale: state.i18n.locale,
  loading: state.iam.loading
});
const mapDispatchToProps = {
  navigate,
  register
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Register);
